import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { hasWindow } from '../../utils';
import { trackEvent } from '../../support-and-tracking/analytics-actions';
import { showErrorModal } from '../../global-message/global-message-actions';
import Image from '../../components/image/Image';
import styles from './lottery-ticket.module.less';

const LotteryTicket = ({
    lotteryIndex,
    imageIndex,
    image,
    setIsFinishedFunction,
    alreadyRevealed,
    scratchAll,
    placeHolder,
    winner,
    winningField,
}) => {
    const scratchContainer = useRef(null);
    const [currentScratchCard, setCurrentScratchCard] = useState(null);
    const dispatch = useDispatch();
    const [showFinishedImage, setShowFinishedImage] = useState(false);

    function clearOldComponents(containerRefCurrent) {
        const innerComponents = containerRefCurrent.getElementsByClassName('sc__inner');
        const canvasComponents = containerRefCurrent.getElementsByClassName('sc__canvas');
        for (const component of canvasComponents) {
            component.remove();
        }
        for (const component of innerComponents) {
            component.remove();
        }
        setCurrentScratchCard(null);
    }

    const instantiateNewScratchCard = () => {
        const ScratchCard = require('@tofandel/scratchcard-js');

        const scratchCardElement = new ScratchCard(`#scratchcontainer${imageIndex}`, {
            scratchType: ScratchCard.type.CIRCLE,
            containerWidth: scratchContainer?.current?.offsetWidth,
            containerHeight: scratchContainer?.current?.offsetHeight,
            imageForwardSrc: placeHolder,
            htmlBackground: `<img
                    src='${image}'
                    loading='eager'
                    class='${[styles.finishedImage, winner && winningField ? styles.winnerWinner : ''].join(' ')}'
                />`,
            clearZoneRadius: 20,
            nPoints: 80,
            pointSize: 4,
            percentToFinish: 10,
            callback: () => finish(true),
        });

        scratchCardElement.ctx.imageSmoothingEnabled = false;
        return scratchCardElement;
    };

    useEffect(() => {
        let isMounted = true;
        let localScratchContainerRef = null;

        finish(alreadyRevealed);
        if (hasWindow() && scratchContainer?.current && !alreadyRevealed) {
            localScratchContainerRef = scratchContainer.current;
            const card = instantiateNewScratchCard();
            card.init()
                .then(() => {
                    if (isMounted) {
                        setCurrentScratchCard(card);
                    }
                })
                .catch(() =>
                    dispatch(
                        showErrorModal(
                            'Det oppsto en feil når vi skulle vise loddet. Prøv igjen! Hvis problemet ikke løser seg, ta kontakt med oss via chatten'
                        )
                    )
                );
        }

        return () => {
            if (hasWindow() && localScratchContainerRef) {
                clearOldComponents(localScratchContainerRef);
            }
            isMounted = false;
        };
    }, [lotteryIndex]);

    useEffect(() => {
        if (scratchAll) {
            finish(true);
        }
    }, [scratchAll]);

    const finish = (finished) => {
        setIsFinishedFunction(finished);
        if (finished) {
            setShowFinishedImage(true);
        }
        if (currentScratchCard && finished) {
            currentScratchCard.clear();
            clearOldComponents(scratchContainer.current);
        }
        trackEvent('support', 'lottery-scratch', { lotteryIndex });
    };

    return (
        <div className={styles.lotteryScratchElement}>
            <div
                id={`scratchcontainer${imageIndex}`}
                ref={scratchContainer}
                className={[styles.scratchContainer].join(' ')}
                onClick={() => finish(true)}
            >
                {showFinishedImage && (
                    <Image
                        src={image}
                        className={[styles.finishedImage, winner && winningField ? styles.winnerWinner : ''].join(' ')}
                        loading={'eager'}
                    />
                )}
            </div>
        </div>
    );
};

export default LotteryTicket;
